export const WINDOW_POSITION = {
  BOTTOM_RIGHT: '1',
  BOTTOM_LEFT: '2',
};
